import React from "react";

const OperationalEfficiency = () => {
  return (
    <div>
      <h1>OperationalEfficiency</h1>
    </div>
  );
};

export default OperationalEfficiency;
